import React from "react";
import { useTranslation } from "react-i18next";
import { Clock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../ui/card";
import { Input } from "../../../ui/input";
import { Label } from "../../../ui/label";
import { Switch } from "../../../ui/switch";

const TunisiaWorkingTimeCard = ({ formData, handleInputChange }) => {
  const { t } = useTranslation();
  return (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Clock className="h-5 w-5" />
        {t("payrollTN.wtTitle")}
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <Label htmlFor="weekly_hours">{t("payrollTN.weeklyHours")}</Label>
          <Input
            id="weekly_hours"
            type="number"
            max="48"
            value={formData.weekly_work_hours}
            onChange={(e) => handleInputChange("weekly_work_hours", parseFloat(e.target.value))}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {t("payrollTN.weeklyHint")}
          </p>
        </div>

        <div>
          <Label htmlFor="daily_hours">{t("payrollTN.dailyHours")}</Label>
          <Input
            id="daily_hours"
            type="number"
            max="8"
            value={formData.daily_work_hours}
            onChange={(e) => handleInputChange("daily_work_hours", parseFloat(e.target.value))}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {t("payrollTN.dailyHint")}
          </p>
        </div>

        <div>
          <Label htmlFor="monthly_hours">{t("payrollTN.monthlyHours")}</Label>
          <Input
            id="monthly_hours"
            type="number"
            step="0.01"
            value={formData.expected_work_hours_per_month}
            onChange={(e) => handleInputChange("expected_work_hours_per_month", parseFloat(e.target.value))}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {t("payrollTN.monthlyHint", { weekly: formData.weekly_work_hours, result: (formData.weekly_work_hours * 52 / 12).toFixed(1) })}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label>{t("payrollTN.saturdayWork")}</Label>
          <p className="text-sm text-muted-foreground">
            {t("payrollTN.saturdayHint")}
          </p>
        </div>
        <Switch
          checked={formData.saturday_working}
          onCheckedChange={(checked) => handleInputChange("saturday_working", checked)}
        />
      </div>
    </CardContent>
  </Card>
  );
};

export default TunisiaWorkingTimeCard;
